import { Dialog } from "@material-ui/core";
import { Button } from "@resource/atlas";
import { atlasArrowLeft, atlasClose } from "@resource/atlas/icons";
import InterviewerProfile from "components/InterviewerProfile/InterviewerProfile";
import { useState } from "react";
import { Interviewer as InterviewerType } from "types/legacy";

import VideoIntro from "./VideoIntro";

type InterviewerModalProps = {
  open: boolean;
  onClose: (...args: InterviewerType[]) => void;
  interviewer: InterviewerType;
};

function InterviewerModal({
  open,
  onClose,
  interviewer,
}: InterviewerModalProps) {
  const [showingVideoIntroductionUrl, setShowingVideoIntroductionUrl] =
    useState(false);
  const { videoIntroductionUrl } = interviewer;

  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth scroll="body">
      {videoIntroductionUrl && showingVideoIntroductionUrl ? (
        <div>
          <div className="px-4 py-2">
            <Button
              icon={atlasArrowLeft}
              isGhost
              className="pl-2.5"
              aria-label="Back to profile"
              onClick={() => setShowingVideoIntroductionUrl(false)}
            />
          </div>
          <div className="px-8 pb-8">
            <VideoIntro mediaLink={videoIntroductionUrl} />
          </div>
        </div>
      ) : (
        <div>
          <div className="flex justify-end px-4 pt-4">
            <Button
              icon={atlasClose}
              className="pr-2.5"
              isGhost
              onClick={() => onClose()}
            />
          </div>
          <div className="px-8 pb-8">
            <InterviewerProfile
              variant="regular"
              personalProfile={interviewer}
              onVideoIntroductionClick={() =>
                setShowingVideoIntroductionUrl(true)
              }
            />
          </div>
        </div>
      )}
    </Dialog>
  );
}

export default InterviewerModal;
